/* KingCase - reglages page produit : taille cachee + bouton Personnaliser plus clair. */
(function(){
  var css = document.createElement('style');
  css.textContent =
    '.kc-sr,variant-picker,.variant-picker,.product-info__variant-picker,[data-block-type="variant-picker"],.product-form__variants{' +
    'position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;' +
    'clip:rect(0,0,0,0)!important;white-space:nowrap!important;opacity:0!important;' +
    'pointer-events:none!important;margin:-1px!important;padding:0!important;border:0!important}' +
    '@keyframes kcpulse{0%,100%{box-shadow:0 0 0 0 rgba(232,35,42,.55)}50%{box-shadow:0 0 0 12px rgba(232,35,42,0)}}' +
    '.kc-trigger{animation:kcpulse 2s ease-in-out infinite}';
  document.head.appendChild(css);

  function inHost(el){ return !!(el.closest && el.closest('[data-kc-host]')); }

  function fields(){
    return [].slice.call(document.querySelectorAll('input, select, textarea')).filter(function(f){
      return f.type !== 'hidden' && f.type !== 'submit' && !inHost(f);
    });
  }

  /* Cache le champ "Taille" de l'ancienne app sur la page produit (l'app le remplit toute seule). */
  function hideTaille(){
    var list = fields();
    [].slice.call(document.querySelectorAll('label, legend, p, span, strong, b, div, h3, h4, h5')).forEach(function(el){
      if(inHost(el) || el.classList.contains('kc-sr')) return;
      if(el.querySelector('input, select, textarea, button')) return;
      var t = (el.textContent || '').trim();
      if(!t || t.length > 40 || !/^taille(\s|:|$)/i.test(t)) return;
      el.classList.add('kc-sr');
      var next = null;
      for(var i = 0; i < list.length; i++){
        if(el.compareDocumentPosition(list[i]) & Node.DOCUMENT_POSITION_FOLLOWING){ next = list[i]; break; }
      }
      if(next) next.classList.add('kc-sr');
    });
  }

  var LABEL =
    '<span style="display:block">\uD83D\uDC49 Personnalise ici tes prot\u00e8ge-tibias</span>' +
    '<span style="display:block;margin-top:5px;font-family:Inter,system-ui,sans-serif;font-weight:500;' +
    'font-size:13px;letter-spacing:0;text-transform:none;opacity:.95">' +
    'Photo, pr\u00e9nom, num\u00e9ro, drapeau \u2014 aper\u00e7u en direct</span>';

  function fixTrigger(){
    var btns = document.querySelectorAll('button[aria-haspopup="dialog"]');
    for(var i = 0; i < btns.length; i++){
      var b = btns[i];
      if(b.dataset.kcLabel) return true;
      if(!/Personnaliser mes prot/i.test(b.textContent || '')) continue;
      b.dataset.kcLabel = '1';
      b.innerHTML = LABEL;
      b.classList.add('kc-trigger');
      new MutationObserver(function(){
        if(/^\s*\u2713/.test(b.textContent || '')) b.classList.remove('kc-trigger');
      }).observe(b, {childList:true, characterData:true, subtree:true});
      return true;
    }
    return false;
  }

  function run(){ fixTrigger(); hideTaille(); }
  run();
  [300, 900, 2500].forEach(function(ms){ setTimeout(run, ms); });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
})();

/* KingCase - bouton "Ajouter au panier" du theme.
   Il est masque visuellement (le bloc rouge devient le seul bouton), mais reste dans la page
   pour que l'appli puisse l'utiliser en fin de personnalisation.
   Securite : si un client arrive quand meme a appuyer dessus sans personnaliser, l'appli s'ouvre.
   Si l'appli ne se charge pas, le bouton reapparait pour ne bloquer personne. */
(function(){
  function host(){ return document.querySelector('[data-kc-host]'); }

  function trigger(){
    var t = document.querySelector('button[aria-haspopup="dialog"][data-kc-label]');
    if(t) return t;
    var list = document.querySelectorAll('button[aria-haspopup="dialog"]');
    for(var i = 0; i < list.length; i++){
      if(/prot|personnalis|photos envoy/i.test(list[i].textContent || '')) return list[i];
    }
    return null;
  }

  /* Masque le bouton du theme et les boutons de paiement express seulement quand l'appli est bien la. */
  var hidden = false;
  function hideAtc(){
    if(hidden || !host() || !trigger()) return;
    hidden = true;
    var s = document.createElement('style');
    s.textContent =
      'form[action*="/cart/add"] [type=submit]:not([aria-haspopup]),' +
      'form[action*="/cart/add"] button[name="add"]:not([aria-haspopup]),' +
      'form[action*="/cart/add"] .shopify-payment-button{' +
      'position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;' +
      'clip:rect(0,0,0,0)!important;opacity:0!important;pointer-events:none!important;' +
      'margin:-1px!important;padding:0!important;border:0!important}';
    document.head.appendChild(s);
  }
  hideAtc();
  [300, 900, 2500, 5000].forEach(function(ms){ setTimeout(hideAtc, ms); });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideAtc);

  function done(){
    var t = trigger();
    if(t && /^\s*\u2713/.test(t.textContent || '')) return true;
    var h = host();
    var inputs = document.querySelectorAll('form[action*="/cart/add"] input[type=file]');
    for(var i = 0; i < inputs.length; i++){
      if(h && h.contains(inputs[i])) continue;
      if(inputs[i].files && inputs[i].files.length) return true;
    }
    return false;
  }

  function atcButton(target){
    if(!target || !target.closest) return null;
    var b = target.closest('form[action*="/cart/add"] [type=submit], form[action*="/cart/add"] button[name="add"]');
    if(!b) return null;
    if(b.getAttribute('aria-haspopup') === 'dialog') return null;
    var h = host();
    if(h && h.contains(b)) return null;
    return b;
  }

  document.addEventListener('click', function(e){
    if(!e.isTrusted) return;
    if(!host()) return;
    if(!atcButton(e.target)) return;
    if(done()) return;
    var t = trigger();
    if(!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    t.click();
  }, true);
})();
